// 북마크 저장소 관리 유틸리티

const BOOKMARK_STORAGE_KEY = 'shorteng_bookmarks';

/**
 * 북마크 데이터 구조:
 * {
 *   id: string (contentId_subtitleIndex),
 *   contentId: string,
 *   contentTitle: string,
 *   subtitleIndex: number,
 *   subtitle: {
 *     english: string,
 *     korean: string,
 *     comment: string,
 *     words: array,
 *     startTime: number,
 *     endTime: number,
 *     audioPath: string
 *   },
 *   timestamp: number (저장 시간)
 * }
 */

// 모든 북마크 가져오기
export const getAllBookmarks = () => {
    try {
        const bookmarks = localStorage.getItem(BOOKMARK_STORAGE_KEY);
        return bookmarks ? JSON.parse(bookmarks) : [];
    } catch (error) {
        console.error('Error loading bookmarks:', error);
        return [];
    }
};

// 북마크 추가
export const addBookmark = (contentId, contentTitle, subtitleIndex, subtitle, accessKey) => {
    try {
        const bookmarks = getAllBookmarks();
        const id = `${contentId}_${subtitleIndex}`;

        // 이미 존재하는지 확인
        const existingIndex = bookmarks.findIndex(b => b.id === id);
        if (existingIndex !== -1) {
            console.log('Bookmark already exists');
            return false;
        }

        const newBookmark = {
            id,
            contentId,
            contentTitle,
            subtitleIndex,
            subtitle: {
                english: subtitle.english,
                korean: subtitle.korean,
                comment: subtitle.comment || '',
                words: subtitle.words || [],
                startTime: subtitle.startTime,
                endTime: subtitle.endTime,
                audioPath: subtitle.audioPath
            },
            accessKey,
            timestamp: Date.now()
        };

        bookmarks.unshift(newBookmark); // 최신 항목을 앞에 추가
        localStorage.setItem(BOOKMARK_STORAGE_KEY, JSON.stringify(bookmarks));
        return true;
    } catch (error) {
        console.error('Error adding bookmark:', error);
        return false;
    }
};

// 북마크 제거
export const removeBookmark = (contentId, subtitleIndex) => {
    try {
        const bookmarks = getAllBookmarks();
        const id = `${contentId}_${subtitleIndex}`;
        const filteredBookmarks = bookmarks.filter(b => b.id !== id);
        localStorage.setItem(BOOKMARK_STORAGE_KEY, JSON.stringify(filteredBookmarks));
        return true;
    } catch (error) {
        console.error('Error removing bookmark:', error);
        return false;
    }
};

// 북마크 여부 확인
export const isBookmarked = (contentId, subtitleIndex) => {
    try {
        const bookmarks = getAllBookmarks();
        const id = `${contentId}_${subtitleIndex}`;
        return bookmarks.some(b => b.id === id);
    } catch (error) {
        console.error('Error checking bookmark:', error);
        return false;
    }
};

// 특정 컨텐츠의 북마크 가져오기
export const getBookmarksByContent = (contentId) => {
    try {
        const bookmarks = getAllBookmarks();
        return bookmarks.filter(b => b.contentId === contentId);
    } catch (error) {
        console.error('Error getting bookmarks by content:', error);
        return [];
    }
};

// 북마크 개수 가져오기
export const getBookmarkCount = () => {
    try {
        const bookmarks = getAllBookmarks();
        return bookmarks.length;
    } catch (error) {
        console.error('Error getting bookmark count:', error);
        return 0;
    }
};
